import { Button } from "common/components/ui/Button";
import {
  Dialog,
  DialogContent,
  DialogDescription,
  DialogTitle,
} from "common/components/ui/Dialog";
import {
  Drawer,
  DrawerContent,
  DrawerDescription,
  DrawerTitle,
} from "common/components/ui/Drawer";
import useTwBreakpoint from "common/hooks/useTwBreakpoint";

export default function ReportReady({
  exportUrl,
  resetUrl,
  isPdf,
}: {
  exportUrl: string;
  resetUrl: () => void;
  isPdf: boolean;
}) {
  const isDesktop = useTwBreakpoint("lg");

  const Component = isDesktop ? Dialog : Drawer;
  const Content = isDesktop ? DialogContent : DrawerContent;
  const Title = isDesktop ? DialogTitle : DrawerTitle;
  const Description = isDesktop ? DialogDescription : DrawerDescription;

  return (
    <Component
      open={!!exportUrl}
      onOpenChange={(open) => {
        if (!open) {
          resetUrl();
        }
      }}
    >
      <Content className="lg:w-[448px]">
        <Title className="mb-2">Your report is ready</Title>
        <Description className="mb-8">
          {isPdf
            ? "Click the button below to open your report"
            : "Click the button below to download your report in CSV format"}
        </Description>
        <Button
          className="max-lg:ml-auto"
          onClick={() => {
            resetUrl();
            window.open(exportUrl);
          }}
        >
          {isPdf ? "Open" : "Download"}
        </Button>
      </Content>
    </Component>
  );
}
